export function listToTree(data,nodeId,parentNodeId) {
    debugger;
    let parents = data.filter(value => value[parentNodeId] == 'undefined' || value[parentNodeId]== null||value[parentNodeId] == "")
    let children = data.filter(value => value[parentNodeId] !== 'undefined' && value[parentNodeId] != null&& value[parentNodeId] != "")
    let translator = (parents, children) => {
        parents.forEach((parent) => {
            children.forEach((current, index) => {
                if (current[parentNodeId] === parent[nodeId]) {
                    let temp = JSON.parse(JSON.stringify(children))
                    temp.splice(index, 1)
                    translator([current], temp)
                    typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
                }
            }
            )
        }
        )
    }

    translator(parents, children)

    return parents
}